// src/types/bookings/BookingStatus.ts
var BookingStatus = /* @__PURE__ */ ((BookingStatus2) => {
  BookingStatus2["Pending"] = "pending";
  BookingStatus2["Confirmed"] = "confirmed";
  BookingStatus2["CheckedIn"] = "checked_in";
  BookingStatus2["Completed"] = "completed";
  BookingStatus2["Rejected"] = "rejected";
  BookingStatus2["Cancelled"] = "cancelled";
  BookingStatus2["NoShow"] = "no_show";
  return BookingStatus2;
})(BookingStatus || {});
var ACTIVE_BOOKING_STATUSES = [
  "pending" /* Pending */,
  "confirmed" /* Confirmed */,
  "checked_in" /* CheckedIn */
];
var PAST_BOOKING_STATUSES = ["completed" /* Completed */];
var TERMINAL_BOOKING_STATUSES = [
  "completed" /* Completed */,
  "rejected" /* Rejected */,
  "cancelled" /* Cancelled */,
  "no_show" /* NoShow */
];

export {
  BookingStatus,
  ACTIVE_BOOKING_STATUSES,
  PAST_BOOKING_STATUSES,
  TERMINAL_BOOKING_STATUSES
};
